<template>

  <el-col
    class="content"
    :xl="{ span: 18 }"
    :lg="{ span: 18 }"
    :md="{ span: 18 }"
    :xs="{ span: 24 }"
    :sm="{ span: 24 }"
  >
    <div class="mydoc">
      <div class="header" style="font-weight: 900">
        {{ $t('software.headerTitle') }}
      </div>
      <div class="mybody">
        <p>
          (1) {{ $t('software.miniSpeechLab.title') }}
          {{ $t('software.miniSpeechLab.description') }}
          {{ $t('software.miniSpeechLab.contact') }}
        </p>
        <div style="display: flex; align-items: center; margin-left: 40px">
          <h4 style="cursor: pointer; color: cornflowerblue; width: fit-content; margin-right: 20px" @click="downloadFile">{{ $t('software.miniSpeechLab.download') }}</h4>
          <h4 style="width: fit-content; color: cornflowerblue">{{ $t('software.miniSpeechLab.downloadCount') }}{{DownloadCount}}</h4>
        </div>
        <p>
          (2){{ $t('software.praat.title') }} {{ $t('software.praat.description') }}
        </p>
        <p>
          (3){{ $t('software.coolEdit.title') }}
          {{ $t('software.coolEdit.description') }}
        </p>
        <p>
          (4){{ $t('software.eprime.title') }}
          {{ $t('software.eprime.description') }}
        </p>
        <p>
          (5){{ $t('software.matlab.title') }}
          {{ $t('software.matlab.description') }}
        </p>
      </div>
    </div>
  </el-col>
</template>>

<script>
import loginComponent from '@/components/loginComponent'
import {getDownloadCount} from '@/api/data'

export default {
  name: "software",
  components: {
    loginComponent
  },
  data() {
    return {
      DownloadCount: ''
    }
  },
  mounted() {
    this.getDownloadCount()
  },
  methods: {
    downloadFile() {
      // 使用本地开发环境的URL
      const baseUrl = process.env.NODE_ENV === 'development' 
        ? 'http://localhost:8850/manuscript' 
        : 'http://www.exp-linguistics.net/manuscript'
      const downloadUrl = `${baseUrl}/file/download`
      
      // 直接打开下载链接
      window.open(downloadUrl, '_blank')
      
      // 显示提示信息
      this.$message.success('开始下载文件')
      
      // 延迟2秒后刷新下载次数(等待后端处理完成)
      setTimeout(() => {
        this.getDownloadCount()
      }, 2000)
    },
    getDownloadCount() {
      getDownloadCount().then(res => {
        console.log(res, '下载次数获取')
        this.DownloadCount = res.data.result
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.el-row {
  //   background-color: white;
  margin: auto;
}

.introduction_pre {
  width: auto;
  margin: 10px 5px 10px 5px; /**边框距离 上右边下左 */
  background-color: white;
  overflow: hidden;
}

.introduction {
  border: 1px solid #b3c0d1;
  height: 920px;
  margin-bottom: 10px;
  border-radius: 5px;
  /* margin-top: 5px; */
}

.about {
  min-height: calc(100vh - 8rem);
}

.showappbox {
  display: flex;

  .left {
    text-align: left;
  }
}

.content {
  margin-top: 12px;

  .mylink {
    height: 18rem;
    border-radius: 4px;
    background: rgba($color: #ffffff, $alpha: 0.5);
    box-shadow: 2px 3px 10px rgb(51, 72, 94);

    .mybody {
      //   padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-around;

      .body-item {
        cursor: pointer;
      }

      .num {
        font-size: 55px;
        font-weight: bold;
      }
    }
  }

  .mydoc {
    border-radius: 4px;
    min-height: 20rem;
    box-shadow: 2px 3px 10px rgb(51, 72, 94);
    text-align: left;

    .mybody {
      //   background: linear-gradient(45deg, #34495e, #41b883);
      height: 940px;
      padding: 10px;
      background-color: white;
      overflow: auto;
    }

    p {
      color: black;
      text-indent: 30px;
      line-height: 24px;
      padding: 10px;
    }
  }
}

.header {
  padding: 10px;
  text-align: left;
  background-color: gainsboro;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom: 1px solid gainsboro;
}
</style>



// WEBPACK FOOTER //
// src/view/software.vue